import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgPaaSCloud = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-paa-s-cloud';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M11.54 4.282a5.3 5.3 0 0 0-1.302.29c-1.758.661-3.014 2.166-3.385 4.053-.037.188-.086.348-.11.354s-.16.033-.303.059c-1.387.256-2.783 1.307-3.512 2.642-1.362 2.495-.592 5.667 1.753 7.217a5.3 5.3 0 0 0 1.811.753l.408.09h10.2l.408-.09c2.334-.517 3.978-2.399 4.215-4.826.183-1.875-.691-3.832-2.191-4.901-.6-.428-1.37-.774-1.972-.885a7 7 0 0 1-.305-.06c-.025-.007-.066-.13-.091-.274-.104-.596-.382-1.357-.673-1.842-1.061-1.767-2.941-2.746-4.951-2.58m1.34 1.579c.347.09.95.376 1.254.594.499.357.998.969 1.246 1.528.084.189.3.853.3.921 0 .009-1.658.016-3.684.016-3.177 0-3.682-.008-3.663-.057.012-.032.035-.126.051-.21.051-.276.326-.889.549-1.224A4.3 4.3 0 0 1 9.98 6.375a4.1 4.1 0 0 1 1.16-.51c.154-.034.316-.072.36-.082.177-.041 1.129.012 1.38.078m4.708 4.727c.671.234 1.037.466 1.532.971a3.9 3.9 0 0 1 1.104 2.381l.027.3H3.749l.027-.3c.143-1.581 1.24-2.939 2.724-3.373.154-.045.334-.09.4-.099s2.415-.015 5.22-.013l5.1.005zm2.324 5.362c-.458 1.049-1.302 1.803-2.413 2.156l-.359.114H6.86l-.36-.114a3.85 3.85 0 0 1-2.412-2.156l-.084-.19h15.992z"
    })
  }));
});
export default SvgPaaSCloud;